import { HttpResponse } from '@angular/common/http';
import { Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.css']
})
export class PreviewComponent implements OnInit {
  fileID: string;
  fileData: any;
  CurUser:User
  constructor(private http:HttpService, private global:GlobalService, private router:Router, private actRoute:ActivatedRoute, private sanitizer:DomSanitizer) { }

  ngOnInit(): void {

    this.fileID = this.actRoute.snapshot.paramMap.get('id');
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
    });
  }

  LoadFile() {
    this.http.DownloadInfoCenterFile(this.CurUser.UserId.toString(), this.fileID).subscribe(({ body, headers }: HttpResponse<any>) => {
      var blo = new Blob([body], { type: 'application/pdf' });
      var sanitized = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blo)));
      this.fileData = sanitized;
    });
  }


}
